import * as React from 'react'

import { Avatar, Box } from '@factorialco/deprecated-design-system'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import type IncidenceMessage from 'modules/bookkeepers/store/models/IncidenceMessage'

import MessageContent from './MessageContent'
import FactorialBotAvatar from './factorial-bot-avatar.svg'

interface Props {
  message: IncidenceMessage
}

const MessageItem = ({ message }: Props) => {
  const avatarUrl = buildUrl(message.attributes.sender_avatar) || FactorialBotAvatar

  return (
    <Box width="full" component="li" gap="s12" flexDirection="row">
      <Avatar
        url={avatarUrl}
        label={
          message?.attributes.sender_name ?? i18n.t('bookkeepers.incidence.message.deleted_user')
        }
        size="s40"
      />
      <MessageContent message={message} />
    </Box>
  )
}

export default MessageItem
